export const blockIconsTravelAirplaneTicketNew = (
	<span className='material-symbols-outlined'>airplane_ticket</span>
);
